import RecurringOrders from './RecurringOrders'

export default RecurringOrders



// WEBPACK FOOTER //
// ./src/components/RecurringOrders/index.js